<template>
  <div class="qlbh">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách đề xuất phí</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="getProposals">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="dateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              v-model="approvalDateRange"
              :locale-data="Config.localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 11.5em; margin-left: -5px !important"
                  class="pt-1 text-center"
                >
                  {{ picker.startDate | formatDate }} -
                  {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="pt-1 font-size-12 time-placeholder">
                  Thời gian duyệt/từ chối
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input
              v-model.trim="search.textSearch"
              type="text"
              placeholder="Từ khóa"
              style="border-radius: 4px"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.deviceType"
              :options="deviceTypes"
              placeholder="Loại thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2 v-model="search.createdBy" :options="staffList" placeholder="Người tạo" />
          </div>
          <div class="form-group">
            <select2-multiple-control
              class="region-select"
              v-model="search.searchRegionId"
              :options="regions"
              :settings="{ placeholder: 'Vùng kinh doanh' }"
            />
          </div>
          <div class="form-group">
            <Select2 placeholder="Trạng thái" v-model="search.status" :options="statusOptions" />
          </div>
          <div class="form-group form-group-action">
            <button
              type="button"
              @click="getProposals()"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>

            <button
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="clearSearch()"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div
              v-if="hasDefaultFilter"
              class="mb-2 d-inline-flex align-items-center"
              style="
                background-color: #fff3e0;
                padding: 6px 12px;
                border-radius: 4px;
                font-size: 13px;
              "
            >
              <i class="bx bx-info-circle mr-1" style="color: #f57c00"></i>
              <span style="color: #e65100">Đang lọc mặc định 3 ngày gần nhất</span>
              <button
                @click="removeDefaultFilter"
                type="button"
                class="ml-2 btn-close-filter"
                style="
                  background: none;
                  border: none;
                  cursor: pointer;
                  padding: 0 4px;
                  color: #e65100;
                  font-size: 16px;
                  line-height: 1;
                "
                title="Bỏ lọc"
              >
                ×
              </button>
            </div>
            <div>
              Tổng:
              <strong class="text-primary">{{ totalProposals || 0 }}</strong>
            </div>

            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="proposals"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(proposalInfo)="data">
                <p>
                  {{ data.item.proposalCode }}
                </p>
              </template>
              <template #cell(appendixCode)="data">
                <p>
                  {{ data.item.appendixCode }}
                </p>
              </template>
              <template #cell(time)="data">
                <p v-if="data.item.createdAt">
                  Tạo:
                  <span>{{ data.item.createdAt | formatDate('DD/MM/YYYY HH:mm') }}</span>
                </p>
                <p v-if="data.item.approvedAt">
                  Duyệt:
                  <span>{{ data.item.approvedAt | formatDate('DD/MM/YYYY HH:mm') }}</span>
                </p>
                <p v-if="data.item.rejectedAt">
                  Từ chối:
                  <span>{{ data.item.rejectedAt | formatDate('DD/MM/YYYY HH:mm') }}</span>
                </p>
                <p v-if="data.item.canceledAt">
                  Hủy:
                  <span>{{ data.item.canceledAt | formatDate('DD/MM/YYYY HH:mm') }}</span>
                </p>
              </template>
              <template #cell(devices)="data">
                <p>
                  SL thiết bị: <strong>{{ data.item.deviceCount }}</strong>
                </p>
                <div v-for="(device, index) in data.item.devices" :key="index">
                  <p>
                    {{ device.deviceType }}: {{ formatMoney(device.oldPrice) }} →
                    {{ formatMoney(device.newPrice) }}
                  </p>
                </div>
              </template>
              <template #cell(createdBy)="data">
                <p v-if="data.item.createdByName">
                  <strong>{{ data.item.createdByName }}</strong>
                </p>
                <p v-if="data.item.createdByEmail">
                  <a href="#">{{ data.item.createdByEmail }}</a>
                </p>
                <!-- <p>{{ data.item.regionName }}</p> -->
              </template>
              <template #cell(region)="data">
                {{ data.item.regionName }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="mapStatusColor(data.item.status)">
                  {{ mapStatus(data.item.status) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="viewDetail(data.item)"
                  >
                    <i class="bx bx-show-alt"></i> Chi tiết
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          v-model="search.page"
          :total-rows="totalProposals"
          :per-page="search.limit"
          class="mr-2 fl-right"
        ></b-pagination>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { ContractService } from '@/services/contract.service'
  import { StaffService } from '@/services/staff.service'
  import { DeviceService } from '@/services/device.service'
  import { getLastNDays } from '@/utils/util'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },

    { key: 'proposalInfo', label: 'Mã phiếu', thStyle: 'min-width: 200px' },
    {
      key: 'appendixCode',
      label: 'Mã phụ lục hợp đồng',
      thStyle: 'min-width: 200px',
    },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 200px' },
    {
      key: 'devices',
      label: 'SL thiết bị/Mã giảm giá',
      thStyle: 'min-width: 250px',
    },
    { key: 'createdBy', label: 'Người tạo', thStyle: 'min-width: 200px' },
    { key: 'region', label: 'Vùng', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái', class: 'text-center' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]

  export default {
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        loading: false,
        showLoading: false,
        proposals: [],
        totalProposals: 0,
        dateRange: {
          startDate: null,
          endDate: null,
        },
        approvalDateRange: {
          startDate: null,
          endDate: null,
        },
        search: {
          page: 1,
          limit: 10,
          textSearch: '',
          deviceType: '',
          createdBy: '',
          status: '',
          searchRegionId: [],
        },
        regions: [],
        staffList: [],
        deviceTypes: [],
        statusOptions: [{ id: '', text: 'Tất cả' }, ...Config.listStatusProposal],
        hasDefaultFilter: true,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      const { from, to } = getLastNDays(3, 'date')
      this.dateRange = {
        startDate: from,
        endDate: to,
      }
      await this.getProposals()
      this.getRegions()
      this.getStaffList()
      this.typeDeviceConfig()
    },
    watch: {
      'search.page': function () {
        this.getProposals()
      },
      'search.limit': function () {
        this.getProposals()
      },
    },
    methods: {
      async typeDeviceConfig() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            this.deviceTypes = data.data.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            })
            this.deviceTypes.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getStaffList() {
        try {
          const userData = JSON.parse(localStorage.getItem('userData'))
          const response = await StaffService.getStaffByIdSuperior({
            userId: userData.userId,
          })
          if (response.data.length > 0) {
            const staffOptions = [{ id: '', text: 'Tất cả' }]
            response.data.forEach(staff => {
              staffOptions.push({
                id: staff.userId,
                text: `${staff.name} - ${staff.userName}`,
              })
            })
            this.staffList = staffOptions
          } else {
            this.staffList = [{ id: '', text: 'Tất cả' }]
          }
        } catch (error) {
          console.error('Error fetching staff list:', error)
        }
      },

      async getRegions() {
        try {
          const response = await StaffService.getRegions()
          if (response.data.length > 0) {
            const regionOptions = [{ id: '', text: 'Tất cả' }]
            response.data.forEach(region => {
              regionOptions.push({
                id: region.id,
                text: region.name,
              })
            })
            this.regions = regionOptions
          }
        } catch (error) {
          console.error('Error fetching regions:', error)
        }
      },

      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },

      formatMoney(value) {
        if (!value) return '0'
        return new Intl.NumberFormat('vi-VN').format(value)
      },
      mapStatusColor(status) {
        const statusMap = Config.listStatusProposal.reduce((acc, curr) => {
          acc[curr.id] = curr.bgColor
          return acc
        })
        return statusMap[status] || status
      },
      mapStatus(status) {
        const statusMap = Config.listStatusProposal.reduce((acc, curr) => {
          acc[curr.id] = curr.text
          return acc
        })
        return statusMap[status] || status
      },

      clearSearch() {
        this.search = {
          page: 1,
          limit: 10,
          textSearch: '',
          deviceType: '',
          createdBy: '',
          status: '',
          searchRegionId: [],
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.approvalDateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.getProposals()
      },

      removeDefaultFilter() {
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.hasDefaultFilter = false
        this.getProposals()
      },

      async getProposals() {
        try {
          this.loading = true
          const params = this.prepareSearchParams()
          const response = await ContractService.getProposals(params)
          console.log(`response`, response)

          if (response.success) {
            this.proposals = response.data || []
            this.totalProposals = response?.totalPage?.total || 0
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.error('Error fetching proposals:', error)
          this.showFailMx(error.message)

          this.proposals = []
          this.totalProposals = 0
        } finally {
          this.loading = false
        }
      },

      prepareSearchParams() {
        const params = { ...this.search }

        // Process date ranges
        if (this.dateRange.startDate) {
          params.createdDateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        }
        if (this.dateRange.endDate) {
          params.createdDateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
        }

        if (this.approvalDateRange.startDate) {
          params.approvedDateFrom = moment(this.approvalDateRange.startDate)
            .startOf('day')
            .valueOf()
        }
        if (this.approvalDateRange.endDate) {
          params.approvedDateTo = moment(this.approvalDateRange.endDate).endOf('day').valueOf()
        }

        // Clean empty values
        Object.keys(params).forEach(key => {
          if (
            params[key] === '' ||
            params[key] === null ||
            (Array.isArray(params[key]) && params[key].length === 0)
          ) {
            delete params[key]
          }
        })

        return params
      },

      viewDetail(item) {
        if (item.contractUrl) {
          window.open(item.contractUrl, '_blank')
        } else {
          window.open(`/proposal-detail/${encodeURIComponent(item.id)}`, '_blank')
        }
      },
    },
  }
</script>

<style>
  .badge {
    padding: 8px 12px;
    font-size: 12px;
    border-radius: 4px;
  }

  .NEW {
    color: #fff;
    background-color: #17a2b8;
  }

  .APPROVED {
    color: #fff;
    background-color: #28a745;
  }

  .REJECTED {
    color: #fff;
    background-color: #dc3545;
  }

  .CANCELED {
    color: #fff;
    background-color: #6c757d;
  }

  .card .card-header .dropdown .dropdown-toggle {
    font-size: 16px !important;
    margin-top: -12px;
  }

  @media screen and (max-width: 480px) {
    .dropdown-menu {
      max-width: 100%;
    }
    .no-gutters {
      overflow-x: auto;
      max-width: 100%;
      margin: 0 auto;
    }
    .daterangepicker .drp-buttons .btn {
      margin-left: 0;
    }
  }

  .btn-close-filter:hover {
    opacity: 0.7;
    transform: scale(1.1);
  }
</style>
